import { render } from "./MySourcerContact.vue?vue&type=template&id=d2ef69e8"
import script from "./MySourcerContact.vue?vue&type=script&lang=js"
export * from "./MySourcerContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__